/**
 * log function
 */
const logger = (...args) => {
  console.log(...args);
};

export default logger;
